import { render, staticRenderFns } from "./gaia48-footer.vue?vue&type=template&id=18d05c68&scoped=true&"
import script from "./gaia48-footer.vue?vue&type=script&lang=js&"
export * from "./gaia48-footer.vue?vue&type=script&lang=js&"
import style0 from "./gaia48-footer.vue?vue&type=style&index=0&id=18d05c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d05c68",
  null
  
)

export default component.exports